import { Box } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';

interface Props {
  spacerHeight?: number;
}

const HeaderMobileWrapper: FunctionComponent<PropsWithChildren<Props>> = ({
  children,
  spacerHeight = 168,
}) => (
  <Box
    sx={{
      background: 'transparent',
      marginBottom: `${spacerHeight}px`,
      transition: 'margin-bottom 0.3s ease',
    }}
  >
    <Box sx={{ width: '100%', position: 'fixed', top: '0', left: '0' }}>{children}</Box>
  </Box>
);

export default HeaderMobileWrapper;
